export default __webpack_public_path__ + "static/media/p4.98aa1e14.png";